import Pannellum from 'lib/pannellum';
import PannellumAdmin from "../../pannellum-poi-editor/pannellum-admin";
import BlurplanManager from './service';
import { generateUUID } from 'lib/helpers/common';
import ModalService from "../service/modal/e3.viewer.modal.service";
import E3Drag from "lib/helpers/draggable";

export default {
    _blurEditorMode : false,
    _blurpoints : [],
    _draggingFloorpoint : [],
    _waitingBlurpoint : false,

    _onDragBlurpoint(element, px, py) {
        let [pitch, yaw] = this._mouseEventToCoords({
            clientX: px,
            clientY: py
        });
        let index = this._blurpoints.findIndex(elPair => elPair.includes(element));
        this._blurplan.updateVertexView([yaw,pitch], index, true, this._blurpoints[index][0] === element);
        this._render();
    },

    _onDragBlurpointFinish(element, pageX, pageY) {
        this._onDragBlurpoint(element, pageX, pageY);
        let index = this._blurpoints.findIndex(elPair => elPair.includes(element));
        this._blurplan.removeVertexSnapData(index);
    },

    blurRender() {
        if (this._loaded && this._blurEditorMode) {
            this._renderBlurPoints();
        }
    },

    blurPrepareInitialConfig(){
        this._initBlurplan(this._initialConfig.e3plan, true, this._initialConfig.title);
    },

    blurFinishInteracting({eventObjects, classname}){
        if (this._waitingBlurpoint) {
            let {x, y} = this._mousePosition(eventObjects[0]);
            let dx = x - this._interactionData.x;
            let dy = y - this._interactionData.y;
            if(Math.sqrt(dx * dx + dy * dy) < 4) {
                let [pitch, yaw] = this._mouseEventToCoords(eventObjects[0]);
                this._renderInteractingBlurpoint(yaw, pitch, classname);
                this._render();
            }
        }
    },

    blurContinueInteracting(eventObjects){
        if(this._waitingBlurpoint && !this._waitingFloorpoint && !this._isUserInteracting && !this._draggingFloorpoint && !this._draggingHotspot) {
            if(eventObjects[0].target === this._dragFix) {
                let [pitch, yaw] = this._mouseEventToCoords(eventObjects[0]);
                this._blurplan.setGhostPoint([yaw, pitch]);
            }
            else {
                this._blurplan.removeGhostPoint();
            }

            if (!this._renderer.isLoading()) requestAnimationFrame(this._animateBound);
        }
    },

    setBlurData(){
        this._destroyBlurplanPoints();
        this._removeAllCloseIcons();

        if(!this._imageData) return ;

        const {blur_polylines_json} = this._imageData;

        if(!this._blurEditorMode || !blur_polylines_json) return ;

        const blurPolylinesJson = JSON.parse(blur_polylines_json);

        this._blurplan.setRectangleVertices(blurPolylinesJson);
        this._createBlurPlan();
    },

    _destroyBlurPoints(){
        this._removeAllCloseIcons();
        this._destroyBlurplanPoints();
    },

    _addBlurListener(){
        this.on('destroy', this._destroyBlurPoints.bind(this));
        this.on('animate-hotspot-transition', this._loadImageDataBlur.bind(this));
        this.on('load-scene', this.setBlurData.bind(this));
        this.on('get-render-params', this._blurGetRenderParams.bind(this));
        this.on('continue-interacting', this.blurContinueInteracting.bind(this));
        this.on('finish-interacting', this.blurFinishInteracting.bind(this));
        this.on('prepare-initial-config', this.blurPrepareInitialConfig.bind(this));
        this.on('render', this.blurRender.bind(this));
    },

    _loadImageDataBlur(){
        if (this._blurEditorMode)  this._loadImageData();
    },

    _blurGetRenderParams(params){
        if (this._blurEditorMode) {
            Object.assign(params, {
                e3Blurplan: this._blurplan.getCubeVertices()
            });
        }
    },

    _initBlurplan(config, isInit = false, title) {
        this._blurplan = new BlurplanManager();
    },

    toggleBlurPlanEditorMode(enable) {
        if(this._blurEditorMode !== enable) {
            this._blurEditorMode = enable;
            this._waitingBlurpoint = enable;
            if(this._blurEditorMode) {
                this._container.classList.add('blur-mode');
                this.setDrawingFinished(false);
                this.setWaitForStartDrawing(true);
            }
            else {
                if(this._container.classList.contains('blur-mode')) this._container.classList.remove('blur-mode');
                this._destroyBlurplanPoints();
                this._removeAllCloseIcons();
            }
        }
        this._render();
    },

    setWaitForStartDrawing(waitForStartDrawing){
        this._fireEvent('blur-wait-for-start-drawing', waitForStartDrawing);
        this.waitForStartDrawing = waitForStartDrawing;
    },

    setDrawingFinished(isDrawingFinished){
        this._fireEvent('blur-is-drawing-finished', isDrawingFinished);
        this.isDrawingFinished = isDrawingFinished;
        this._blurplan.setDrawingFinished(this.isDrawingFinished);
    },

    _createBlurPlan() {
        this._blurplan.getRectangleVertices()
            .forEach(({uuid}) => {
                this.addCloseElement(uuid);
            })

        this._renderBlurPoints();
        this.showRectangleCounter();
    },

    getBlurPolylinesQuery() {
        return  this._blurplan.getBlurPolylinesQuery();
    },

    getBlurPolylines() {
        return  this._blurplan.getBlur2dPolylines();
    },

    setBlurPlan(rectangleVertices) {
        this._blurplan.setRectangleVertices(rectangleVertices);
    },

    _bindBlurpointEvents(element) {
        E3Drag.init(element,
            () => {},
            this._onDragBlurpoint.bind(this),
            this._onDragBlurpointFinish.bind(this),
            this._onTapBlurpoint.bind(this, element),
            {threshold: 4}
        );
        element.style.touchAction = 'none';
    },

    async _onTapBlurpoint(element) {
        if(element.id.match(/rectangle/)) return this.onBlurCloseclick(element);
        if(this._blurpoints.length < 2) return false;

        let index = this._blurpoints.findIndex(elPair => elPair.includes(element));

        if(index > 0) return;

        const uuid = generateUUID();
        this.addCloseElement(uuid);
        this._blurplan.pushToRectangleVertices(uuid, false, true);

        this._render();
        this.setWaitForStartDrawing(true);
        this.setDrawingFinished(true);
        this._blurpoints[0].forEach((val) => val.classList.remove('last-floorpoint'));
        this._destroyBlurplanPoints();
        this.showRectangleCounter();
    },

    applyBlur(){
        this._blurConfirmModal('CONFIRM_BLUR_IMAGE')
            .then((confirmed) => {
                if(confirmed){
                    this._fireEvent('save-blur-polylines');
                }
            })
            .catch((e) => {
                console.log(e)
            })
    },

    _blurConfirmModal(title){
        return new Promise((res, rej) => {
            try{
                const modalService = new ModalService(this._container, this._translateService);
                const handlers = {
                    'chat-modal-close': () => {
                        modalService.close('confirm');
                        res(false);
                    },
                };

                modalService.confirm(this._translate(title), (confirmed) => {
                    modalService.close('confirm');
                    res(confirmed);
                }, '',true, handlers)
            }catch (e){
                rej(e);
            }
        })
    },

    showRectangleCounter(){
        const count = this._blurplan.countRectangle();
        const polylines = this._blurplan.getBlur2dPolylines();

        this._fireEvent('blur-show-rectangle-counts', {count, polylines});
    },

    async onBlurCloseclick(element) {
        const uuid = element.id.match(/(^rectangle_)(.+)/)[2];

        this.removeBlurPoint(uuid);
    },

    removeBlurPoint(uuid){
        if(this._blurplan.isBlurred(uuid)){
            const modalService = new ModalService(this._container, this._translateService);

            const handlers = {
                'chat-modal-close': () => {
                    modalService.close('confirm');
                    this.removeBlurPointAndrectangle(uuid);
                },
            };

            modalService.alertWithButton(this._translate('CONTINUE_DRAWING_OR_APPLY_FOR_TAKE_EFFECT'), () => {
                modalService.close('confirm');
                this.removeBlurPointAndrectangle(uuid);
            }, '',true, handlers)
        }else{
            this.removeBlurPointAndrectangle(uuid)
        }
    },

    removeBlurPointAndrectangle(uuid) {
        this._blurplan.removeRectangle(uuid);
        this.removeCloseIcon(uuid);
        this.showRectangleCounter();
    },

    removeCloseIcon(uuid){
        if(!this._closeElement.length) return ;

        const el = this._closeElement.filter((el) => el[0].id === `rectangle_${uuid}`)[0][0];

        PannellumAdmin.unbindFloorpointEvents(el);
        el.parentNode.removeChild(el);
        this._closeElement = this._closeElement.filter((el) => el[0].id !== `rectangle_${uuid}`);
    },

    addCloseElement(uuid){
        this._closeElement.push(this._createBlurPoints('modal-close', uuid));
    },

    blurDestroy(){
        this._blurplan.destroy();
    },

    _renderInteractingBlurpoint(yaw, pitch, classname) {
        this.setWaitForStartDrawing(false);
        this._blurplan.addPoint([yaw, pitch]);
        this._blurpoints.push(this._createBlurPoints(classname));
    },

    _createBlurPoints(classname, id) {
        classname = !classname ? '' : classname;
        let bottomElem = document.createElement('div');
        bottomElem.className = `pnlm-floorpoint ${classname} pnlm-blurpoint`;
        if(typeof id !== 'undefined') bottomElem.setAttribute("id", `rectangle_${id}`);

        this._bindBlurpointEvents(bottomElem);

        this._renderContainer.appendChild(bottomElem);
        return [bottomElem];
    },

    _renderBlurPoints() {
        this._blurplan.getVerticesSpherCoords().forEach((coords, i) => {
            this._renderHotSpotElement(...coords[0].map(c=>c/Pannellum.RADIAN), this._blurpoints[i][0], undefined, 'blurPoint');
        });

        if (this._blurplan.getBountingCoordCount() > 0) {
            try{
                this._blurplan.getBountingCoordVerticesSpherCoords().forEach(({bountingCoord, uuid}, i) => {
                    const el = this._closeElement.filter((el) => el[0].id === `rectangle_${uuid}`)[0];

                    if(el) this._renderHotSpotElement(...bountingCoord[0].map(c=>c/Pannellum.RADIAN), el[0], undefined, 'blurPoint');
                });
            }catch (e){
                console.log(e)
            }
        }
    },

    _destroyBlurplanPoint(index) {
        this._blurpoints.splice(index, 1)[0].forEach(el => {
            PannellumAdmin.unbindFloorpointEvents(el);
            el.parentNode.removeChild(el);
        });
    },

    _destroyBlurplanPoints() {
        while(this._blurpoints.length) {
            this._destroyBlurplanPoint(this._blurpoints.length - 1);
        }
    },

    removeBlur(){
        if(this.waitForStartDrawing){
            this.removeAllBlurRectangles();
        }else{
            this.removeCurrentBlurArea();
        }


        this.setWaitForStartDrawing(true);
    },

    removeAllBlurRectangles(){
        this._blurConfirmModal('CONFIRM_REJECT_ALL_BLUR_RECTANGLE')
            .then((confirmed) => {
                if(confirmed){
                    const elements = this._removeAllCloseIcons();

                    elements.forEach((element) => {
                        const uuid = element.id.match(/(^rectangle_)(.+)/)[2];

                        this._blurplan.removeRectangle(uuid);
                    })

                    this.showRectangleCounter();
                    // this._fireEvent('save-blur-polylines');
                }
            })
            .catch((e) => {
                console.log(e);
            })
    },

    removeCurrentBlurArea(){
        this._destroyBlurplanPoints();
        this._blurplan.removeCurrentBlurArea();
    },

    _removeAllCloseIcons(){
        const elements = this._closeElement.map((el) => el[0]);

        elements.forEach((element) => {
            const uuid = element.id.match(/(^rectangle_)(.+)/)[2];

            this.removeCloseIcon(uuid);
        });

        return elements;
    },

    getBlurCartCoord(){
        return this._blurplan.getBlurCartCoord();
    }
}
